import { Tooltip } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

/**
 * Aviso de que os totais do resumo seguem os filtros da tela (10/10/2026). Sem
 * ele, quem filtra e olha o card acha que o pedido inteiro encolheu.
 */
export function AvisoDoFiltro({ filtros, compacto = false }: { filtros: number; compacto?: boolean }) {
    if (!filtros) return null;

    const texto = `Conforme ${filtros} filtro${filtros === 1 ? '' : 's'}`;

    return (
        <Tooltip title="Os totais somam só os produtos que passam nos filtros da tela. Sem filtro, é o relatório inteiro.">
            <small className={`resumo-filtrado${compacto ? ' resumo-filtrado--compacto' : ''}`}>
                <FilterOutlined />
                {compacto ? 'Filtrado' : texto}
            </small>
        </Tooltip>
    );
}
